import React from "react";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DateSection from "../Cards/CardComponents/DateSection";
import TitleAndLocation from "../Cards/CardComponents/TitleAndLocation";
import { useState } from "react";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { useSelector } from "react-redux";

const ReviewCartItems = ({ cart, type, parentData }) => {
  const translations = useSelector((state) => state.language.translations);
  const [showSummary, setShowSummary] = useState(false);

  const navigate = useNavigate();
  const handleClick = () => {
    if (type === "PUJA") {
      navigate("/puja");
    } else if (type === "OFFERING") {
      navigate("/chadawa");
    } else {
      navigate("/");
    }
  };

  const paymentSummary = () => {
    return (
      <div className="w-full px-3 py-4 bg-white sm:bg-custom-beige rounded-2xl inline-flex flex-col justify-start items-start gap-2">
        <div className="self-stretch flex flex-col justify-start items-start gap-3">
          <div className="self-stretch inline-flex justify-between items-center">
            <div className="flex justify-start items-center gap-2">
              <ReceiptLongIcon className="text-neutral-800" />
              <div className="text-neutral-800 text-base font-medium font-['Poppins']">
                Payment Summary
              </div>
            </div>
          </div>
          <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-200"></div>

          {cart?.itemList
            ?.filter((item) => item.subType === "PUJA_PACKAGE")
            .concat(
              cart?.itemList.filter((item) => item.subType !== "PUJA_PACKAGE")
            )
            .map((item) => (
              <div
                key={item.itemId}
                className="self-stretch inline-flex justify-between items-center"
              >
                <div className="flex justify-center items-center gap-1">
                  <div className="text-neutral-800 text-sm font-normal font-['Poppins']">
                    {item.name}
                  </div>
                </div>
                <div className="flex justify-end items-center gap-1">
                  <div className="flex justify-start items-start gap-1">
                    <div className="text-neutral-800 text-sm font-normal font-['Poppins']">
                      ₹ {item.totalAmount}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>

        <div className="self-stretch opacity-80 flex flex-col justify-start items-center gap-2">
          <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-200"></div>
          <div className="self-stretch flex flex-col justify-start items-start gap-0.5">
            <div className="self-stretch inline-flex justify-between items-center">
              <div className="flex justify-start items-start gap-1">
                <div className="text-neutral-800 text-sm font-medium font-['Poppins']">
                  To Pay
                </div>
              </div>
              <div className="text-neutral-800 text-sm font-semibold font-['Poppins']">
                ₹{" "}
                {cart?.itemList?.length > 0
                  ? cart?.totalAmount
                  : "No item available"}
              </div>
            </div>
            <div className="self-stretch inline-flex justify-start items-end gap-12">
              <div className="flex justify-start items-start gap-1">
                <div className="text-zinc-500 text-[10px] font-medium font-['Poppins']">
                  Incl. all taxes and charges
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full min-h-full bg-light-pink sm:bg-custom-beige pt-2 sm:pt-0 lg:rounded-l-[24px] relative">
      <div className="w-full lg:border-b-2 lg:border-gray-300 h-[65px] items-center px-4 flex">
        <h1 className="text-xl font-semibold text-gray-700 flex items-center">
          <ArrowBackIcon className="mr-2" onClick={handleClick} />{" "}
          {translations.reviewBooking}
        </h1>
      </div>

      <div className="flex flex-col justify-between sm:bg-custom-beige">
        <div className="px-6 md:px-10 lg:px-16 pt-3 pb-10 hidden md:block">
          {/* Show loading if `parentData` is empty */}
          {!parentData || parentData.length === 0 ? (
            <div className="flex justify-center items-center py-10">
              <p className="text-gray-500">Loading...</p>
            </div>
          ) : (
            <>
              <DateSection
                eventDateTime={
                  parentData?.eventDateTime ||
                  parentData?.mainSection?.eventDateTime
                }
              />
              <div className="pt-3 flex flex-col justify-center items-center">
                {parentData?.mainSection?.titleImageInfo.url ? (
                  <img
                    className="w-full aspect-[7/4] rounded-[24px]"
                    src={parentData?.mainSection?.titleImageInfo.url}
                    alt="Puja"
                  />
                ) : (
                  <p className="text-gray-500">No image available</p>
                )}
              </div>
              <TitleAndLocation offering={parentData?.mainSection} />
            </>
          )}
        </div>
        <div
          className="sm:bg-custom-beige bg-opacity-100 w-full px-4 sm:px-8 md:px-10 lg:px-16 md:rounded-[24px] border-gray-600 sm:py-6 pb-2 md:relative"
          onClick={() => setShowSummary(!showSummary)}
        >
          <h2 className="text-lg font-bold text-custom-orange mb-4 text-center hidden md:block">
            {translations.bookingSummary}
          </h2>
          <div className="flex items-center justify-between sm:block rounded-xl bg-custom-maroon sm:bg-inherit mb-4">
            <h4 className="text-[3.5vw] sm:text-lg text-custom-beige px-6 pt-4 sm:text-custom-orange mb-4">
              {parentData?.mainSection?.name}
            </h4>

            <div
              className="sm:hidden ml-auto mr-4 text-custom-beige px-3 py-2 rounded-md flex items-center transition-transform duration-400 ease-in-out"
              style={{
                transform: showSummary ? "rotate(180deg)" : "rotate(0deg)",
              }}
            >
              <KeyboardArrowDownIcon />
            </div>
          </div>

          <div
            className={`transition-all ease-in-out transform block sm:hidden ${
              showSummary
                ? "opacity-100 scale-100 max-h-[1000px] translate-y-0 duration-500"
                : "opacity-0 scale-95 max-h-0 -translate-y-4 overflow-hidden duration-500"
            }`}
            style={{
              transitionProperty: "opacity, transform, max-height",
              transitionTimingFunction: showSummary
                ? "cubic-bezier(0.4, 0, 0.2, 1)"
                : "cubic-bezier(0.4, 0, 0.6, 1)",
            }}
          >
            <div
              className={`transition-opacity ${
                showSummary ? "duration-300 delay-150" : "duration-300 delay-0"
              }`}
            >
              {paymentSummary()}
            </div>
          </div>

          <div className="hidden sm:block">{paymentSummary()}</div>

          {!showSummary && (
            <div
              className="bg-white py-5 px-6 rounded-2xl items-center sm:hidden transition-all duration-400 ease-in-out transform"
              style={{
                animation: showSummary
                  ? "fadeOut 0.4s ease-out"
                  : "fadeIn 0.45s ease-in 0.2s both",
              }}
            >
              <div className="flex justify-between">
                <span className="font-semibold text-gray-700">
                  {translations.totalPrice}
                </span>
                <span className="font-semibold text-custom-orange">
                  ₹{" "}
                  {cart?.itemList?.length > 0
                    ? cart?.totalAmount
                    : "No item available"}
                </span>
              </div>
            </div>
          )}

          <style jsx>{`
            @keyframes fadeIn {
              from {
                opacity: 0;
                transform: translateY(10px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }

            @keyframes fadeOut {
              from {
                opacity: 1;
                transform: translateY(0);
              }
              to {
                opacity: 0;
                transform: translateY(-10px);
              }
            }
          `}</style>
        </div>
      </div>
    </div>
  );
};

export default ReviewCartItems;
